import React, { useRef, useState } from "react"
import { Grid, Button, CircularProgress } from "@material-ui/core"

import {
	ChatMessageBuilder
} from "@/components"

import { ChatMessageBuilderHandler, Message } from "@/components/ChatMessageBuilder"
import { BuildedMessage } from "@/protocols/messages"

type MessagesProps = {
	isMessageBlastSent: boolean,
	messages: BuildedMessage[],
	onSave: (messages: BuildedMessage[] | Message[]) => void | Promise<void>
}

const Messages: React.FC<MessagesProps> = ({
	isMessageBlastSent,
	messages,
	onSave
}) => {
	const [savingMessages, setSavingMessages] = useState(false)
	const chatMessageBuilderRef = useRef<ChatMessageBuilderHandler>(null)

	const handleSave = async () => {
		setSavingMessages(true)

		const updatedMessages = chatMessageBuilderRef.current?.getMessages() || messages
		chatMessageBuilderRef.current?.blur()
		await onSave(updatedMessages)

		setSavingMessages(false)
	}

	return (
		<Grid container justify="flex-end" spacing={2}>
			<Grid item xs={12}>
				<ChatMessageBuilder
					renderWithInitialMessage
					disabled={isMessageBlastSent}
					disabledMessage="Você não pode editar uma mensagem após o envio."
					ref={chatMessageBuilderRef}
					initialMessages={messages}
					disabledInputs={["quick-reply"]}
				/>
			</Grid>

			{!isMessageBlastSent && (
				<Grid item>
					<Button
						variant="contained"
						color="primary"
						onClick={handleSave}
						endIcon={savingMessages && <CircularProgress size={20} />}
						disabled={savingMessages}
					>
						SALVAR
					</Button>
				</Grid>
			)}
		</Grid>
	)
}

export default Messages
